"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aiPricing = exports.AiModel = void 0;
var AiModel;
(function (AiModel) {
    AiModel["GPT_3_5_TURBO"] = "gpt-3.5-turbo";
    AiModel["GPT_3_5_TURBO_16k"] = "gpt-3.5-turbo-16k";
    AiModel["GPT_4"] = "gpt-4";
    AiModel["GPT_4_32k"] = "gpt-4-32k";
    AiModel["GPT_4_TURBO"] = "gpt-4-turbo";
    AiModel["WHISPER"] = "whisper-1";
    AiModel["DOCUMENT_AI"] = "document-ai";
    AiModel["GOOGLE_PALM2"] = "google-palm2";
    AiModel["GPT_CUSTOM_MODEL"] = "GPT_CUSTOM_MODEL";
    AiModel["CLAUDE_3_OPUS"] = "claude-3-opus-20240229";
    AiModel["CLAUDE_3_SONNET"] = "claude-3-sonnet-20240229";
    AiModel["DALL_E_3"] = "dall-e-3";
    AiModel["GPT_4O"] = "gpt-4o";
    AiModel["GPT_4O_MINI"] = "gpt-4o-mini";
    AiModel["ASSEMBLY_AI"] = "assembly-ai";
    AiModel["CLAUDE_3_5_SONNET"] = "claude-3-5-sonnet-20240620";
})(AiModel || (exports.AiModel = AiModel = {}));
// pricing per 1000 tokens.
exports.aiPricing = {
    [AiModel.GPT_3_5_TURBO]: {
        prompt_tokens: 0.0015,
        completion_tokens: 0.002,
    },
    [AiModel.GPT_3_5_TURBO_16k]: {
        prompt_tokens: 0.003,
        completion_tokens: 0.004,
    },
    [AiModel.GPT_4]: {
        prompt_tokens: 0.03,
        completion_tokens: 0.06,
    },
    [AiModel.GPT_4_TURBO]: {
        prompt_tokens: 0.01,
        completion_tokens: 0.03,
    },
    [AiModel.GPT_4_32k]: {
        prompt_tokens: 0.06,
        completion_tokens: 0.12,
    },
    [AiModel.WHISPER]: {
        audio_minutes: 0.006,
    },
    [AiModel.DOCUMENT_AI]: {
        per_document_processing_fee: 0.006, // not quite sure
    },
    [AiModel.GOOGLE_PALM2]: {
        per_1k_chars_input: 0.0005,
        per_1k_chars_output: 0.0005,
    },
    [AiModel.GPT_CUSTOM_MODEL]: {
        prompt_tokens: 0.003,
        completion_tokens: 0.004, // 아무 값이나 넣었음
    },
    [AiModel.DALL_E_3]: {
        prompt_tokens: 0.03,
        completion_tokens: 0.06, // 아무 값이나 넣었음
    },
    [AiModel.GPT_4O]: {
        prompt_tokens: 0.005,
        completion_tokens: 0.015, // $15.00 / 1M tokens
    },
    [AiModel.ASSEMBLY_AI]: {
        audio_minutes: 0.006,
    },
    [AiModel.CLAUDE_3_5_SONNET]: {
        prompt_tokens: 0.003,
        completion_tokens: 0.015,
    },
    [AiModel.CLAUDE_3_OPUS]: {
        prompt_tokens: 0.015,
        completion_tokens: 0.075,
    },
    [AiModel.CLAUDE_3_SONNET]: {
        prompt_tokens: 0.003,
        completion_tokens: 0.015,
    },
    [AiModel.GPT_4O_MINI]: {
        prompt_tokens: 0.00015,
        completion_tokens: 0.0006, // $4.50 / 1M tokens
    },
};
